import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import PersonIcon from "@mui/icons-material/Person";
import BadgeIcon from "@mui/icons-material/Badge";
import CloseIcon from "@mui/icons-material/Close";
import DriverFormDialog from "./DriverFormDialog";

function DriverSelectDialog({
  open,
  onClose,
  onSuccess,
  onPick,
  customerData,
  carData,
}) {
  const [openDialog, setOpenDialog] = useState(false);

  const handleCarSkip = () => {
    onPick && onPick([]);
    onClose && onClose();
  };

  const handleSelect = async (carData, driverData) => {
    onPick && onPick(driverData);
    onClose && onClose();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth="lg"
        PaperProps={{
          sx: {
            borderRadius: "16px",
            height: "45vh",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle className="bg-white border-b border-gray-100 p-4 sm:p-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <div>
             <h2 className="text-xl font-bold text-gray-800 flex items-center gap-2">
              <span className="w-10 h-10 rounded-full bg-indigo-50 flex items-center justify-center text-indigo-600">
                <PersonIcon />
              </span>
              <span>
                เลือกคนขับรถ
                {carData && (
                    <span className="text-base font-normal text-gray-500 ml-2">
                        สำหรับรถ {carData.license} ({carData.type})
                    </span>
                )}
              </span>
            </h2>
          </div>
          <div className="flex gap-2 w-full sm:w-auto">
            <button
              onClick={() => setOpenDialog(true)}
              className="flex items-center justify-center gap-2 px-4 py-2 bg-indigo-50 text-indigo-700 hover:bg-indigo-100 rounded-xl font-medium transition-all text-sm w-full sm:w-auto"
            >
              <AddIcon fontSize="small" />
              เพิ่มคนขับ
            </button>
            <button onClick={onClose} className="p-2 text-gray-400 hover:bg-gray-100 rounded-full transition-colors sm:block hidden">
                <CloseIcon />
            </button>
          </div>
        </DialogTitle>

        <DialogContent className="bg-slate-50/50 p-6 overflow-y-auto custom-scrollbar">
          {customerData?.drivers?.length ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-2">
              {customerData.drivers.map((driver) => (
                <div
                  key={driver.id}
                  onClick={() => handleSelect(carData, driver)}
                  className="group bg-white border border-gray-200 rounded-2xl p-5 hover:border-indigo-300 hover:shadow-lg hover:shadow-indigo-500/5 cursor-pointer transition-all duration-200 flex flex-col gap-3 relative overflow-hidden"
                >
                    <div className={`absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-indigo-50 to-white rounded-bl-full -mr-10 -mt-10 transition-transform group-hover:scale-110 z-0`}></div>
                    
                    <div className="relative z-10 flex items-start justify-between">
                         <div className="p-3 rounded-xl bg-indigo-50 text-indigo-600">
                            <PersonIcon />
                         </div>
                    </div>

                    <div className="relative z-10">
                        <h3 className="font-bold text-lg text-gray-800 mb-1">
                          {driver.name} {driver.surname}
                        </h3>
                         <div className="flex items-center gap-2 text-sm text-gray-500 font-medium">
                            <BadgeIcon fontSize="small"  color="action" style={{ fontSize: 16 }} />
                            {driver.idCard || "ไม่ระบุเลขบัตร"}
                        </div>
                    </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="h-full flex flex-col items-center justify-center text-gray-400 min-h-[300px]">
                <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                    <PersonIcon sx={{ fontSize: 40, opacity: 0.3 }} />
                </div>
                <p className="text-lg font-medium text-gray-500">ไม่มีข้อมูลคนขับรถ</p>
                <p className="text-sm">กดปุ่ม "เพิ่มคนขับ" เพื่อเริ่มต้นใช้งาน</p>
            </div>
          )}
        </DialogContent>

        <DialogActions className="bg-white border-t border-gray-100 p-4 sm:px-6 flex justify-between">
          <button
            onClick={handleCarSkip}
             className="px-6 py-2.5 rounded-xl text-gray-500 font-medium hover:bg-gray-50 hover:text-gray-700 transition-all text-sm"
          >
            ข้าม / ไม่ระบุคนขับ
          </button>
          <button
            onClick={onClose}
            className="px-8 py-2.5 rounded-xl border border-gray-200 text-gray-600 font-bold hover:bg-gray-50 transition-all text-sm"
          >
            ยกเลิก
          </button>
        </DialogActions>
      </Dialog>

      <DriverFormDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        customerData={customerData}
        onSuccess={onSuccess}
      />
    </>
  );
}

export default DriverSelectDialog;
